import BookingCustomerInfo from '../booking/BookingCustomerInfo';
import type { Customer } from '../../lib/customers';
import type { TodoItemWithRelations } from '../../lib/todos';

function asCustomer(customer: NonNullable<TodoItemWithRelations['customer']>): Customer {
  return {
    id: customer.id,
    first_name: customer.first_name,
    last_name: customer.last_name,
    email: customer.email,
    phone: customer.phone,
  } as Customer;
}

interface TodoTaskCustomerCardProps {
  customer: NonNullable<TodoItemWithRelations['customer']>;
  businessId?: string;
  onOpenCustomer: (customer: Customer) => void;
}

export default function TodoTaskCustomerCard({
  customer,
  businessId,
  onOpenCustomer,
}: TodoTaskCustomerCardProps) {
  const row = asCustomer(customer);

  return (
    <div
      className="mt-2 border-t border-gray-100/80 pt-2"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <BookingCustomerInfo
        customer={row}
        canEdit
        onEdit={() => onOpenCustomer(row)}
        mobile_booking={false}
        businessId={businessId}
        dense
      />
    </div>
  );
}
